import axios from 'axios';

// ריק = אותו דומיין. בפיתוח src/setupProxy.js מעביר /api לשרת המקומי
const BaseUrl = process.env.REACT_APP_API_URL || '';
const APP_ID = 1;

// ── התחברות. הטוקן והשם נשמרים בדפדפן; השרת בודק את הטוקן בכל קריאה (fnGetUserIdByToken) ──
const TOKEN_KEY = 'auth-token';
const USER_KEY = 'currentUser';
// נשלח כשהשרת מחזיר code 90 (טוקן פג / משתמש נחסם). ZolBakfarApp מאזין ומחזיר למסך הכניסה
export const AUTH_EXPIRED_EVENT = 'auth-expired';
// "חיפוש שוב" מהפרופיל (ProfileListModal): detail = טקסט החיפוש. MainPage עובר לטאב החיפוש, SearchTab מריץ
export const RUN_SEARCH_EVENT = 'run-search';

// פעולות שנשלחות בלי טוקן (ר' Auth.sql)
const NO_TOKEN_ACTIONS = new Set(['SignIn', 'SignUp']);

const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || ''; } catch (e) { return ''; }
};

// { userId, firstName, lastName } או null. userId - למפתח של רשימת הקניות (basketStore)
const getCurrentUser = () => {
  try { return getToken() ? JSON.parse(localStorage.getItem(USER_KEY)) : null; } catch (e) { return null; }
};

const saveLogin = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  // termsVersion - איזו גרסה של תנאי השימוש המשתמש אישר (ישנה מ-TERMS_VERSION → TermsUpdateDialog)
  localStorage.setItem(USER_KEY, JSON.stringify({
    userId: user.userId, firstName: user.firstName, lastName: user.lastName, termsVersion: user.termsVersion ?? null,
  }));
};

// אחרי עדכון פרטים בעמוד הפרופיל (spUpdateProfile) - השם בכותרת מתעדכן בלי להתחבר מחדש
const updateCurrentUser = (patch) => {
  const user = getCurrentUser();
  if (!user) return;
  try { localStorage.setItem(USER_KEY, JSON.stringify({ ...user, ...patch })); } catch (e) { /* חסום */ }
};

// רק מפתחות ההתחברות - רשימת ההשלמה האוטומטית (search-suggestions) נשארת
const clearLogin = () => {
  try { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); } catch (e) { /* חסום */ }
};

// מחזיר את תשובת ה-SP כמו שהיא: [[{code,msg}], [...rows], ...]
const requestData = async (action, params) => {
  const token = NO_TOKEN_ACTIONS.has(action) ? '' : getToken();
  const now = new Date();
  const createAt = new Date(now - now.getTimezoneOffset() * 60000).toISOString().slice(0, 19).replace('T', ' ');
  const response = await axios.post(`${BaseUrl}/api/ver1/run`, { action, params: { ...params } },
                                    { headers: { token, appId: APP_ID, createAt } });

  // code 90 = לא מחובר / הטוקן פג / המשתמש נחסם → חזרה למסך הכניסה
  if (response.data?.[0]?.[0]?.code === 90 && !NO_TOKEN_ACTIONS.has(action)) {
    clearLogin();
    window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
  }

  return response.data;
};

const utils = { requestData, getToken, getCurrentUser, saveLogin, updateCurrentUser, clearLogin };

export default utils;
